var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OptionDashboard relative",class:_vm.noti ? 'scroll_unset' : ''},[_c(_vm.OptionComponent,{tag:"component"}),_c('NotificationModal',{on:{"hideNoti":_vm.hideNoti,"showNoti":_vm.showNoti}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }